import Swiper, {Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper';
import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", function (event) {

    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');

    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    const sliders = document.querySelectorAll('.swiper');

    // init Swiper:
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: autoSwiper,

            autoplay: autoSwiper ? {
                delay: 5000,
            } : false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });

    });



    const eventFilters = document.querySelectorAll('[data-behaviour="eventfilter"]');
    const eventPills = document.querySelectorAll('[data-behaviour="eventpill"]');

    if (eventFilters.length > 0 && eventPills.length > 0) {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if( urlParams.has('place') ) {
            eventFilters.forEach(function (eventFilter) {
                if (eventFilter.getAttribute('data-type') === "place") {
                    eventFilter.value = urlParams.get('place');
                }
            });
        }
        if( urlParams.has('category') ) {
            eventFilters.forEach(function (eventFilter) {
                if (eventFilter.getAttribute('data-type') === "category") {
                    eventFilter.value = urlParams.get('category');
                }
            });
        }
        if( urlParams.has('agegroup') ) {
            eventFilters.forEach(function (eventFilter) {
                if (eventFilter.getAttribute('data-type') === "agegroup") {
                    eventFilter.value = urlParams.get('agegroup');
                }
            });
        }

        var filterValues = {
            place: 'all',
            tag: 'all',
            agegroup: 'all'
        };

        const eventEntries = document.querySelectorAll('[data-behaviour="event"]');
        var events = [];

        eventEntries.forEach(function (eventEntry) {
            const pills = eventEntry.querySelectorAll('[data-behaviour="eventpill"]');

            const placespills = Array.from(pills).filter(function (pill) {
                return pill.getAttribute('data-type') === 'place';
            });

            const categorypills = Array.from(pills).filter(function (pill) {
                return pill.getAttribute('data-type') === 'tag';
            });

            const agegrouppills = Array.from(pills).filter(function (pill) {
                return pill.getAttribute('data-type') === 'agegroup';
            });

            const event = {
                id: eventEntry.getAttribute('data-id'),
                title: eventEntry.getAttribute('data-title'),
                places: placespills.map(function (pill) {
                    return pill.getAttribute('data-content');
                }),
                categories: categorypills.map(function (pill) {
                    return pill.getAttribute('data-content');
                }),
                agegroups: agegrouppills.map(function (pill) {
                    return pill.getAttribute('data-content');
                }),
            };
            events.push(event);
        });

        //console.log(events);

        eventFilters.forEach(function (eventFilter) {
            eventFilter.addEventListener('change', function () {
                filterValues[eventFilter.getAttribute('data-type')] = this.value;
                updateEventFilters(filterValues, events);
            });

            filterValues[eventFilter.getAttribute('data-type')] = eventFilter.value;
        });
    }

    let news_collapse = document.querySelectorAll('[data-behaviour="news-collapse"]');
    if(news_collapse.length > 0) {
        news_collapse.forEach(function (news) {
            const news_content = news.parentNode.parentNode.parentNode.querySelector('.news_content');
            news_content.style.maxHeight = '0px';

            news.addEventListener('click', function () {
                news.parentNode.parentNode.classList.toggle('news--expanded');
                if(news.parentNode.parentNode.classList.contains('news--expanded')) {
                    news_content.style.maxHeight = "100%";
                    //news_content.style.maxHeight = news_content.scrollHeight + 'px';
                } else {
                    news_content.style.maxHeight = '0px';
                }
            });

            if(news.parentNode.parentNode.classList.contains('news--expanded')) {
                news_content.style.maxHeight = news_content.scrollHeight + 'px';
            } else {
                news_content.style.maxHeight = '0px';
            }
        });
    }
});

function updateEventFilters(filtervalues, events) {
    //console.log("Updated Filters", filtervalues);

    events.forEach(function (event) {
        let showEvent = true;

        //check if the event contains the selected place
        var placeIsInEvent = false;
        if (filtervalues.place === 'all') {
            placeIsInEvent = true;
        } else {
            event.places.forEach(function (place) {
                if (place === filtervalues.place) {
                    placeIsInEvent = true;
                }
            });
        }

        //check if the event contains the selected category
        var categoryIsInEvent = false;
        if (filtervalues.tag === 'all') {
            categoryIsInEvent = true;
        } else {
            event.categories.forEach(function (category) {
                if (category === filtervalues.tag) {
                    categoryIsInEvent = true;
                }
            });
        }

        //check if the event contains the selected agegroup
        var agegroupIsInEvent = false;
        if (filtervalues.agegroup === 'all') {
            agegroupIsInEvent = true;
        } else {
            event.agegroups.forEach(function (agegroup) {
                if (agegroup === filtervalues.agegroup) {
                    agegroupIsInEvent = true;
                }
            });
        }

        //if the event does not contain the selected place, category and agegroup, hide it
        if (!placeIsInEvent || !categoryIsInEvent || !agegroupIsInEvent) {
            showEvent = false;
        }

        const eventEntry = document.querySelector('[data-id="' + event.id + '"]');
        if (showEvent) {
            eventEntry.classList.remove('hidden');
        } else {
            eventEntry.classList.add('hidden');
        }
    });
}
